/*
 * @Author: Chris 
 * @Date: 2022-07-27 13:44:54 
 * @Last Modified by: Chris
 * @Last Modified time: 2022-09-22 11:33:39
 */

<template>
  <div class="header_whtiout">
    <img class="logo" src="../../assets/IMG/header/header_01.png" alt="" />
  </div>
</template>

<script>
export default {
  name: "ChangeOrgModal",
};
</script>

<style lang="scss" scoped>
.header_whtiout {
  z-index: 10;
  width: 100%;
  background: #b7282d;
  height: 3.75rem;
  display: flex;
  align-items: center;
  .logo {
    margin-left: 2%;
    width: 7.5rem;
    height: 1.9375rem;
  }
}
</style>